export const MarkupsTypesMapping = Object.freeze({
  'Asset.Compliance.EditTypes': 'Compliance Edits',
  'Asset.ProgramTimings.Name': 'Program Timings',
  'Asset.QualityControl.Types': 'Quality Control'
});
